export const GET_INVESTOR_DOCUMENTS_SUCCESS = 'GET_INVESTOR_DOCUMENTS_SUCCESS';
export const SET_INVESTOR_DOCUMENTS_LOADING = 'SET_INVESTOR_DOCUMENTS_LOADING';
